//should be moved to the epic or action by STRY0045127, use connect with redux rather then then this function

export function SetAuthToken(token: string){
    sessionStorage.setItem("wf2-STRY0045127", token);
}
export function GetAuthToken(): string | null {
    return sessionStorage.getItem("wf2-STRY0045127");
}
export function ClearAuth(){
    localStorage.removeItem("portalImage");
    //this assumes everything in the session is sensitive..
    sessionStorage.clear()
}

export function SetSSOToken(token: string){
    sessionStorage.setItem("SSOToken", token);
}
export function GetSSOToken(): string {
    const v = sessionStorage.getItem("SSOToken");
    if(v){
        return v;
    }
    return "";
}

export function SetSiteSearchMode(){
  sessionStorage.setItem("SiteSearch", "true");
}

export function SetEmbeddedOrderMode(){
  sessionStorage.setItem("EmbeddedOrder", "true");
}

export function SiteSearchModeEnabled(): boolean {
  const v = sessionStorage.getItem("SiteSearch");
  if(v){
      return v == "true";
  }
  return false;
}

export function EmbeddedOrderModeEnabled(): boolean {
  const v = sessionStorage.getItem("EmbeddedOrder");
  if(v){
      return v == "true";
  }
  return false;
}

export function SetSSOPayload(data: string){
  sessionStorage.setItem("SSOPayload", data);
}
export function GetSSOPayload(): string {
  const v = sessionStorage.getItem("SSOPayload");
  if(v){
      return v;
  }
  return "";
}

export function SetSSOAction(data: string){
  sessionStorage.setItem("SSOAction", data || "");
}

export function GetSSOAction(): string {
  const v = sessionStorage.getItem("SSOAction");
  if(v){
      return v;
  }
  return "";
}